<template>
  <div class="pagebox">
    <div class="successimg">
      <img src="../../../../assets/refund/icon_successful@2x.png" alt />
    </div>
    <div class="succcesstxt">提交成功</div>
    <div @click="detail" class="btn">查看退货详情</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flowId: ""
    };
  },
  created() {
    this.flowId = this.$route.query.flowId;
  },
  methods: {
    detail() {
      this.$router.replace({
        path: "/refund/refundDetail",
        query: {
          flowId: this.flowId
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.pagebox {
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  padding-top: 194px;
  .successimg {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }
  .succcesstxt {
    font-size: 20px;
    color: #333333;
    font-weight: 600;
    margin-bottom: 260px;
  }
  .btn {
    border: 1px solid #36b374;
    font-size: 16px;
    color: #36B374;
    font-weight: 400;
    border-radius: 4px;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
    padding: 16px 0;
    // margin-top: 50px;
    width: 100%;
  }
}
</style>
